import React, { useState, useContext, useEffect, useRef } from "react";
import ReactLoading from "react-loading";
import { config } from "../../config";
import CommonBtn from "../../components/buttons/commonBtn";
import { StatusContext } from "../../contexts/Status.context";
import MenuList from "../../constants/menu.constants";
import useTranslation from "../../hooks/useTranslation";
import ReactPlayer from "react-player";

const videoList: any = {
  introduction: [
    {
      video: "screenflow/screenflow-intro.mp4",
      subtitle: "screenflow-intro.vvt",
    },
  ],
  "traning: expressions": [
    {
      video: "screenflow/screenflow-howtospot.mp4",
      subtitle: "screenflow-howtospot.vvt",
    },
  ],
  "traning: lies": [
    {
      video: "screenflow/screenflow-howtodetectlies.mp4",
      subtitle: "screenflow-howtodetectlies.vvt",
    },
  ],
  cautions: [
    {
      video: "screenflow/screenflow-cautions.mp4",
      subtitle: "screenflow-cautions.vvt",
    },
  ],
  "questions & answers": [
    {
      video: "screenflow/screenflow-qnan.mp4",
      subtitle: "screenflow-qnan.vvt",
    },
  ],
  anger: [
    {
      video: "training/screenflow-ang1.mp4",
      subtitle: "screenflow-ang1.vvt",
    },
    {
      video: "training/screenflow-ang2.mp4",
      subtitle: "screenflow-ang2.vvt",
    },
    {
      video: "training/screenflow-ang3.mp4",
      subtitle: "screenflow-ang3.vvt",
    },
    {
      video: "training/screenflow-ang4.mp4",
      subtitle: "screenflow-ang4.vvt",
    },
    {
      video: "training/screenflow-ang5.mp4",
      subtitle: "screenflow-ang5.vvt",
    },
    {
      video: "training/screenflow-ang6.mp4",
      subtitle: "screenflow-ang6.vvt",
    },
  ],
  sadness: [
    {
      video: "training/screenflow-sad1.mov",
      subtitle: "screenflow-sad1.vvt",
    },
    {
      video: "training/screenflow-sad2.mp4",
      subtitle: "screenflow-sad2.vvt",
    },
    {
      video: "training/screenflow-sad3.mp4",
      subtitle: "screenflow-sad3.vvt",
    },
    {
      video: "training/screenflow-sad4.mp4",
      subtitle: "screenflow-sad4.vvt",
    },
    {
      video: "training/screenflow-sad5.mp4",
      subtitle: "screenflow-sad5.vvt",
    },
    {
      video: "training/screenflow-sad6.mp4",
      subtitle: "screenflow-sad6.vvt",
    },
  ],
  surprise: [
    {
      video: "training/screenflow-sur1.mov",
      subtitle: "screenflow-sur1.vvt",
    },
    {
      video: "training/screenflow-sur2.mp4",
      subtitle: "screenflow-sur2.vvt",
    },
    {
      video: "training/screenflow-sur3.mp4",
      subtitle: "screenflow-sur3.vvt",
    },
    {
      video: "training/screenflow-sur4.mp4",
      subtitle: "screenflow-sur4.vvt",
    },
  ],
  contempt: [
    {
      video: "training/screenflow-con1.mp4",
      subtitle: "screenflow-con1.vvt",
    },
    {
      video: "training/screenflow-con2.mp4",
      subtitle: "screenflow-con2.vvt",
    },
  ],
  disgust: [
    {
      video: "training/screenflow-dis1.mp4",
      subtitle: "screenflow-dis1.vvt",
    },
    {
      video: "training/screenflow-dis2.mp4",
      subtitle: "screenflow-dis2.vvt",
    },
  ],
  happiness: [
    {
      video: "training/screenflow-hap1.mp4",
      subtitle: "screenflow-hap1.vvt",
    },
    {
      video: "training/screenflow-hap2.mp4",
      subtitle: "screenflow-hap2.vvt",
    },
  ],
  fear: [
    {
      video: "training/screenflow-fea1.mp4",
      subtitle: "screenflow-fea1.vvt",
    },
    {
      video: "training/screenflow-fea2.mp4",
      subtitle: "screenflow-fea2.vvt",
    },
    {
      video: "training/screenflow-fea3.mp4",
      subtitle: "screenflow-fea3.vvt",
    },
    {
      video: "training/screenflow-fea4.mp4",
      subtitle: "screenflow-fea4.vvt",
    },
    {
      video: "training/screenflow-fea5.mp4",
      subtitle: "screenflow-fea5.vvt",
    },
  ],
};

const Train = () => {
  const { pageStatus, setPageStatus, setEngine } = useContext(StatusContext);

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [videoIdx, setVideoIdx] = useState(0);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const trainMenuList = MenuList[0].children[2].children || [];
    const index =
      trainMenuList?.findIndex((item) => item.shortDesc === pageStatus) || 0;
    setIndex(index);
  }, [pageStatus]);

  const handleBack = () => {
    setEngine("menu");
    setPageStatus("Training menu");
  };

  const handleNext = () => {
    const trainMenuList = MenuList[0].children[2].children || [];
    setPageStatus(trainMenuList[index + 1].shortDesc);
    setVideoIdx(0);
  };

  return (
    <div className="block lg:w-[80%] xl:w-[60%] lg:mx-auto">
      <div className="lg:w-[100%]">
        <div className="relative">
          <div className="mt-2 w-3/4 mx-auto border-4 border-gray-500 rounded mb-8 bg-gray-600">
            <div className="w-full pt-[56.5%] relative">
              <div className="absolute top-0 left-0 right-0">
                <ReactPlayer
                  url={
                    config.awsS3CDN +
                    (videoList[pageStatus.toLocaleLowerCase()]
                      ? videoList[pageStatus.toLocaleLowerCase()][videoIdx]
                          .video || ""
                      : "")
                  }
                  playing={true}
                  controls={true}
                  loop={true}
                  muted={false}
                  playsinline={true}
                  width="100%"
                  height="100%"
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                        disablePictureInPicture: true,
                      },
                      tracks: [
                        {
                          kind: "subtitles",
                          src:
                            "/assets/subtitle/en/" +
                            (videoList[pageStatus.toLocaleLowerCase()]
                              ? videoList[pageStatus.toLocaleLowerCase()][
                                  videoIdx
                                ].subtitle || ""
                              : ""),
                          srcLang: "en",
                          default: true,
                          label: "English",
                        },
                        {
                          kind: "subtitles",
                          src:
                            "/assets/subtitle/es/" +
                            (videoList[pageStatus.toLocaleLowerCase()]
                              ? videoList[pageStatus.toLocaleLowerCase()][
                                  videoIdx
                                ].subtitle.replace(".vvt", ".es.vtt") || ""
                              : ""),
                          srcLang: "es",
                          label: "Spanish",
                        },
                        {
                          kind: "subtitles",
                          src:
                            "/assets/subtitle/de/" +
                            (videoList[pageStatus.toLocaleLowerCase()]
                              ? videoList[pageStatus.toLocaleLowerCase()][
                                  videoIdx
                                ].subtitle.replace(".vvt", "-de.vtt") || ""
                              : ""),
                          srcLang: "de",
                          label: "German",
                        },
                      ],
                    },
                  }}
                />
              </div>
            </div>
          </div>
          {isLoading && (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <ReactLoading type="spokes" />
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <div className="mx-1 my-1">
          <CommonBtn status={0} onClick={handleBack}>
            {t("Back")}
          </CommonBtn>
        </div>
        {index < 11 && (
          <div className="mx-1 my-1">
            <CommonBtn status={0} onClick={handleNext}>
              {t("Next")}
            </CommonBtn>
          </div>
        )}
      </div>
      {videoList[pageStatus.toLocaleLowerCase()]?.length > 1 && (
        <div className="flex flex-wrap justify-center mt-2">
          {videoList[pageStatus.toLocaleLowerCase()].map(
            (item: any, index: number) => (
              <button
                className="train-step-btn m-1"
                onClick={() => setVideoIdx(index)}
              >
                {index + 1}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default Train;
